import { memo, useCallback } from 'react'
import { ComponentWithPermissions } from '../../../../baseComponents/CreateRoutering/types'
import { memoChecker } from '../../../../utils/globals/components'
import { TwinDictionary } from '../../../../utils/globals/dictionary'
import { ChangeValueFunc } from '../../../../utils/globals/types'
import useConfigColumns, { SelectedColumnsAndFilters } from '../../../../utils/hooks/useConfigColumns'
import useTwinTranslation from '../../../../utils/hooks/useTwinTranslation'
import { SearchBarWithDebounce } from '../../../SearchBar'
import TableWithCustomVirtualListing from '../../TableWithCustomVirtualListing'
import { HeaderChangesTy, TableConfiguration } from '../../types'
import { InputTableHookProps, ITHookFunctionTy, InputTableFooterFullProps, ColumnITLayoutTableConfiguration, ITHookFunctionResult } from './types'
import { ButtonConfigColumnsWithModal } from '../../../ModalsLayouts/ModalConfigColumnsTabs'

type InputTableProps = ComponentWithPermissions & InputTableHookProps & {
    tableConfiguration: TableConfiguration
    columns: ColumnITLayoutTableConfiguration[]
    className?: string
    hideNotes?: boolean
    name: string
    tableTitle?: string
    TableChildren: React.FC<InputTableFooterFullProps>
    hookFunction: ITHookFunctionTy
    headerChanges?: HeaderChangesTy
    orderStatusDict: TwinDictionary
}


const InputTable: React.FC<InputTableProps> = ({ completeData, className, tableConfiguration, columns, name, TableChildren, hookFunction, headerChanges, tableTitle, ...rest}) => {
    const { setSelectedColumnsAndFilters, selectedColumnsAndFilters, memorizedColumns } = useConfigColumns({ columns, name })
    const { parsedColumns, rowRenderer, containerRenderer, onChangeSearchBar, filters, ...resty } = hookFunction({ completeData, columns: memorizedColumns, ...rest })
    const parsedTableData = completeData?.filteredTableData || completeData.tableData
    const parseFilteredData = useCallback((rowIndex: number) => {
        return completeData?.tableData?.[completeData.dictPosTableData?.[parsedTableData?.[rowIndex].id]]
    }, [completeData.dictPosTableData, completeData.tableData, parsedTableData])
    return (
        <div className={'flex-col flex-auto flex input_table_contents ' + (className || '')} >
            <div className='flex flex-wrap gap-10 justify-between items-center'>
                {tableTitle ? <span className='regular18'>{tableTitle}</span> : <SearchBarInputTable onChange={onChangeSearchBar} /> }
                <div>
                    <ButtonConfigColumnsWithModal name={name} columns={columns} setSelectedColumnsAndFilters={setSelectedColumnsAndFilters} selectedColumnsAndFilters={selectedColumnsAndFilters} haveFiltersColumn={false} setTableConfiguration={() => { }} getTableDataFromStart={() => {}} />
                </div>
            </div>
            <div className='mt-30 flex flex-col flex-auto' >
                <div className={'flex flex-col flex-auto h-1 min-h-300 ' + (completeData?.tableData?.length !== parsedTableData?.length ? 'searching_input_table' : '')}>
                    <div className='flex-auto input_table_table'>
                        <TableWithCustomVirtualListing columns={parsedColumns} data={parsedTableData || []} rowRenderer={rowRenderer} containerRenderer={containerRenderer} setSelectedColumnsAndFilters={setSelectedColumnsAndFilters} name={name} updateEmployeeParameter={true} headerChanges={{ changeOrder: () => { }, changeSingleField: resty.eventFunctions.changeSingleField }} filters={filters} getDataFnc={completeData?.filteredTableData ? parseFilteredData : undefined} />
                    </div>
                </div>
                <TableChildren {...{ completeData, columns: memorizedColumns, parsedTableData, onChangeSearchBar, ...rest , ...resty}} />
            </div>
        </div>
    )
}

interface SearchBarInputTableProps {
    onChange: ChangeValueFunc
}

export const SearchBarInputTable: React.FC<SearchBarInputTableProps> = memo(({ onChange }) => {
    const { t } = useTwinTranslation()
    return (
        <SearchBarWithDebounce className='search_bar_table' searchValue='' onChange={onChange} placeholder={t('search', 'Buscar')} debounce={300} />
    )
}, (oldProps, nextProps) => memoChecker(oldProps, nextProps, ['onChange']))

type InputTableNewProps = InputTableProps & ITHookFunctionResult & {
    selectedColumnsAndFilters: SelectedColumnsAndFilters
    setSelectedColumnsAndFilters: React.Dispatch<React.SetStateAction<SelectedColumnsAndFilters>>
    memorizedColumns: any
}

export const InputTableNew: React.FC<InputTableNewProps> = ({ completeData, className, tableConfiguration, columns, name, TableChildren, hookFunction, headerChanges, tableTitle, memorizedColumns, setSelectedColumnsAndFilters, selectedColumnsAndFilters, parsedColumns, rowRenderer, containerRenderer, filters, eventFunctions, onChangeSearchBar, ...rest }) => {
    const parsedTableData = completeData?.filteredTableData || completeData.tableData
    const parseFilteredData = useCallback((rowIndex: number) => {
        return completeData?.tableData?.[completeData.dictPosTableData?.[parsedTableData?.[rowIndex].id]]
    }, [completeData.dictPosTableData, completeData.tableData, parsedTableData])
    return (
        <div className={'flex-col flex-auto flex input_table_contents ' + (className || '')} >
            <div className='mt-30 flex flex-col flex-auto' >
                <div className={'flex flex-col flex-auto h-1 min-h-250 ' + (completeData?.tableData?.length !== parsedTableData?.length ? 'searching_input_table' : '')}>
                    <div className='flex-auto input_table_table'>
                        <TableWithCustomVirtualListing columns={parsedColumns} data={parsedTableData || []} rowRenderer={rowRenderer} containerRenderer={containerRenderer} setSelectedColumnsAndFilters={setSelectedColumnsAndFilters} name={name} updateEmployeeParameter={true} headerChanges={{ changeOrder: () => { }, changeSingleField: eventFunctions.changeSingleField }} filters={filters} getDataFnc={completeData?.filteredTableData ? parseFilteredData : undefined} />
                    </div>
                </div>
                <TableChildren {...{ completeData, columns: memorizedColumns, parsedTableData, onChangeSearchBar, eventFunctions, ...rest }} />
            </div>
        </div>
    )
}

export default InputTable